// English translations
export const en = {
  // Common
  brandName: "VAROTRADES Inc",
  login: "Log In",
  register: "Register",
  logout: "Log Out",
  dashboard: "Dashboard",
  settings: "Settings",
  adminPanel: "Admin Panel",
  search: "Search",
  viewAll: "View All",
  learnMore: "Learn More",
  getStarted: "Get Started",
  downloadApp: "Download App",
  
  // Navigation
  nav: {
    trade: "Trade",
    markets: "Markets",
    earn: "Earn",
    learn: "Learn",
    more: "More",
    spotTrading: "Spot Trading",
    spotTradingDesc: "Buy and sell 2,000+ cryptocurrencies",
    futures: "Futures",
    futuresDesc: "Trade with up to 125x leverage",
    marginTrading: "Margin Trading",
    marginTradingDesc: "Amplify your trading power",
    copyTrading: "Copy Trading",
    copyTradingDesc: "Follow top traders automatically",
    tradingBots: "Trading Bots",
    tradingBotsDesc: "Automate your strategies 24/7",
    p2pTrading: "P2P Trading",
    p2pTradingDesc: "Trade directly with others",
    marketOverview: "Market Overview",
    marketOverviewDesc: "All markets and prices",
    cryptocurrencies: "Cryptocurrencies",
    cryptocurrenciesDesc: "BTC, ETH, and 2000+ more",
    newListings: "New Listings",
    newListingsDesc: "Latest token additions",
    topGainers: "Top Gainers",
    topGainersDesc: "Best performers today",
    simpleEarn: "Simple Earn",
    simpleEarnDesc: "Flexible savings up to 12% APY",
    staking: "Staking",
    stakingDesc: "Lock and earn rewards",
    launchpool: "Launchpool",
    launchpoolDesc: "Farm new tokens",
    hodlerAirdrops: "HODLer Airdrops",
    hodlerAirdropsDesc: "Rewards for holders",
    cryptoAcademy: "Crypto Academy",
    cryptoAcademyDesc: "Courses for all levels",
    videoTutorials: "Video Tutorials",
    videoTutorialsDesc: "Step-by-step guides",
    articlesGuides: "Articles & Guides",
    articlesGuidesDesc: "In-depth knowledge",
    helpCenter: "Help Center",
    helpCenterDesc: "FAQs and support",
    aboutUs: "About Us",
    aboutUsDesc: "Our story and mission",
    security: "Security",
    securityDesc: "How we protect you",
    proofOfReserves: "Proof of Reserves",
    proofOfReservesDesc: "100% transparency",
    careers: "Careers",
    careersDesc: "Join our team",
  },
  
  // Hero Section
  hero: {
    title1: "Your Gateway to",
    title2: "Cryptocurrency",
    subtitle: "Trusted by over",
    traders: "49 million",
    tradersText: "traders worldwide",
    continueWith: "Or continue with",
  },
  
  // Stats
  stats: {
    volume24h: "24h Trading Volume",
    cryptocurrencies: "Cryptocurrencies",
    simpleEarnApy: "Simple Earn APY",
    reserveRatio: "Reserve Ratio",
  },
  
  // Products
  products: {
    title: "Trade Anytime, Anywhere",
    subtitle: "Diverse products to suit all trading strategies",
    spotTrading: "Spot Trading",
    spotDesc: "2000+ pairs",
    futures: "Futures",
    futuresDesc: "Up to 125x leverage",
    copyTrading: "Copy Trading",
    copyDesc: "Follow experts",
    tradingBots: "Trading Bots",
    botsDesc: "24/7 automated",
    simpleEarn: "Simple Earn",
    earnDesc: "Flexible yields",
    launchpool: "Launchpool",
    launchDesc: "New tokens",
    popular: "Popular",
    hot: "Hot",
    easy: "Easy",
    smart: "Smart",
    earn: "Earn",
    exclusive: "Exclusive",
  },
  
  // How to Start
  howToStart: {
    title: "How to Get Started",
    step1Title: "Create Account",
    step1Desc: "Sign up and get exclusive welcome rewards",
    step2Title: "Quick Purchase",
    step2Desc: "Buy crypto in simple, easy steps",
    step3Title: "Start Trading",
    step3Desc: "Trade, copy trades, and earn more",
    welcomeBonus: "Welcome Bonus",
    forNewUsers: "For new users",
  },
  
  // Security
  security: {
    title: "We Protect Every Trade",
    subtitle: "Multi-layer security to protect your assets",
    advancedSecurity: "Advanced Security",
    advancedSecurityDesc: "Audited smart contracts and on-chain monitoring prevent vulnerabilities",
    proofOfReserves: "Proof of Reserves",
    proofOfReservesDesc: "First platform to provide 100% reserves with transparent audits",
    secureStorage: "Secure Storage",
    secureStorageDesc: "Strategic cold wallet storage to protect your assets",
  },
  
  // CTA
  cta: {
    title: "Start Your Journey Today",
    subtitle: "Join millions of traders around the world and enjoy a safe and reliable trading experience",
    createAccount: "Create Free Account",
    exploreMarkets: "Explore Markets",
  },
  
  // Footer
  footer: {
    products: "Products",
    services: "Services",
    support: "Support",
    company: "Company",
    legal: "Legal",
    description: "A trusted global trading platform for millions of users. Trade securely and transparently.",
    downloadApp: "Download App",
    sslEncrypted: "SSL Encrypted",
    reserves: "Reserves",
    securityAudited: "Security Audited",
    allRightsReserved: "All rights reserved",
    riskWarning: "Risk Warning: Cryptocurrency trading involves high risk. Make sure you understand the risks before trading.",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    riskDisclosure: "Risk Disclosure",
    amlPolicy: "AML Policy",
    helpCenter: "Help Center",
    faq: "FAQ",
    fees: "Fees",
    apiDocs: "API Docs",
    submitRequest: "Submit Request",
    aboutVAROTRADES: "About VAROTRADES",
    news: "News",
    partnerships: "Partnerships",
    buyCrypto: "Buy Crypto",
  },
  
  // Promo Banner
  promo: {
    signUpNow: "Sign up now and get up to",
    upTo: "",
    inRewards: "in rewards",
  },
  
  // Price Card
  priceCard: {
    hot: "Hot",
    new: "New",
    gainers: "Gainers",
  },
  
  // Partners
  partners: {
    officialPartner: "Official Partner:",
  },
  
  // Login Page
  loginPage: {
    title: "Log In",
    welcome: "Welcome back to VAROTRADES",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password?",
    loggingIn: "Logging in...",
    continueWith: "Or continue with",
    noAccount: "Don't have an account?",
    registerNow: "Register Now",
    demoAccount: "Demo account:",
    invalidCredentials: "Invalid email or password",
    twoFactorTitle: "Two-Factor Authentication",
    twoFactorDesc: "Enter the code from your authenticator app",
    verify: "Verify",
    goBack: "Go Back",
    invalidCode: "Invalid verification code",
  },
  
  // Register Page
  registerPage: {
    title: "Create Account",
    subtitle: "Join VAROTRADES today",
    welcomeBonus: "$100 Welcome Bonus",
    bonusDesc: "Register now and claim your bonus",
    firstName: "First Name",
    lastName: "Last Name",
    confirmPassword: "Confirm Password",
    agreeToTerms: "I agree to the",
    termsOfService: "Terms of Service",
    and: "and",
    privacyPolicy: "Privacy Policy",
    creatingAccount: "Creating Account...",
    createAccount: "Create Account",
    registerWith: "Or register with",
    haveAccount: "Already have an account?",
    mustAgree: "You must agree to the Terms of Service",
    passwordMismatch: "Passwords do not match",
    passwordLength: "Password must be at least 6 characters",
    accountFailed: "Failed to create account",
  },
  
  // Markets Page
  marketsPage: {
    title: "Markets",
    subtitle: "Track prices, market caps, and trading volumes",
    totalMarketCap: "Total Market Cap",
    volume24h: "24h Volume",
    btcDominance: "BTC Dominance",
    activeCryptos: "Active Cryptos",
    all: "All",
    hot: "Hot",
    newListings: "New Listings",
    topGainers: "Top Gainers",
    topLosers: "Top Losers",
    searchCoins: "Search coins...",
    filter: "Filter",
    name: "Name",
    price: "Price",
    change24h: "24h Change",
    volume: "24h Volume",
    action: "Action",
    trade: "Trade",
    loadMore: "Load More",
    readyToTrade: "Ready to Start Trading?",
    joinMillions: "Join millions of traders and start your crypto journey today",
  },
  
  // Learn Page
  learnPage: {
    title: "Learn",
    titleHighlight: "Crypto",
    titleEnd: "Trading",
    subtitle: "Free courses, tutorials, and guides to master cryptocurrency trading",
    searchPlaceholder: "Search courses, articles, videos...",
    all: "All",
    beginner: "Beginner",
    trading: "Trading",
    security: "Security",
    defi: "DeFi",
    featuredCourses: "Featured Courses",
    viewAll: "View All",
    videoTutorials: "Video Tutorials",
    articlesGuides: "Articles & Guides",
    faq: "Frequently Asked Questions",
    faqSubtitle: "Quick answers to common questions",
    viewAllFaqs: "View All FAQs",
    readyToPractice: "Ready to Put Your Knowledge to Work?",
    startTradingConfidence: "Start trading with confidence using what you've learned",
    startTradingNow: "Start Trading Now",
    lessons: "lessons",
    views: "views",
    minRead: "min read",
  },
  
  // Company Page
  companyPage: {
    title: "About",
    titleHighlight: "VAROTRADES",
    subtitle: "Building the future of finance by making cryptocurrency accessible, secure, and simple for everyone.",
    registeredUsers: "Registered Users",
    countriesServed: "Countries Served",
    dailyVolume: "Daily Trading Volume",
    cryptocurrencies: "Cryptocurrencies",
    ourStory: "Our Story",
    ourStoryP1: "Founded in 2017, VAROTRADES began with a simple mission: to make cryptocurrency trading accessible to everyone, regardless of their experience level or location.",
    ourStoryP2: "What started as a small team of passionate crypto enthusiasts has grown into a global platform serving millions of users across more than 160 countries.",
    ourStoryP3: "Today, we're proud to be one of the world's leading cryptocurrency exchanges, trusted by traders and investors worldwide.",
    ourValues: "Our Values",
    ourValuesSubtitle: "The principles that guide everything we do",
    securityFirst: "Security First",
    securityFirstDesc: "We prioritize the safety of our users' assets with industry-leading security measures.",
    userCentric: "User-Centric",
    userCentricDesc: "Every decision we make is guided by what's best for our users.",
    innovation: "Innovation",
    innovationDesc: "We continuously push boundaries to provide cutting-edge trading solutions.",
    globalAccess: "Global Access",
    globalAccessDesc: "Making cryptocurrency accessible to everyone, everywhere.",
    securityTrust: "Security & Trust",
    securityTrustSubtitle: "Your security is our top priority",
    proofOfReserves: "Proof of Reserves",
    proofOfReservesDesc: "100% of user assets are backed and verifiable on-chain at any time.",
    coldStorage: "Cold Storage",
    coldStorageDesc: "Majority of assets are stored in secure, offline cold wallets.",
    regularAudits: "Regular Audits",
    regularAuditsDesc: "Third-party security audits ensure our systems meet the highest standards.",
    insuranceFund: "Insurance Fund",
    insuranceFundDesc: "A dedicated fund to protect users against unforeseen circumstances.",
    leadershipTeam: "Leadership Team",
    leadershipSubtitle: "Meet the people driving our mission forward",
    globalPresence: "Global Presence",
    globalPresenceSubtitle: "Serving users worldwide with regional support",
    joinOurTeam: "Join Our Team",
    joinTeamDesc: "We're always looking for talented individuals who share our passion for cryptocurrency and innovation. Explore our open positions and become part of the VAROTRADES family.",
    viewOpenPositions: "View Open Positions",
    teamMembers: "Team Members",
    countries: "Countries",
    openRoles: "Open Roles",
    remoteFriendly: "Remote Friendly",
    getInTouch: "Get in Touch",
    getInTouchSubtitle: "Have questions? We're here to help",
    emailUs: "Email Us",
  },
  
  // Chat Widget
  chat: {
    title: "VAROTRADES Assistant",
    online: "Online",
    welcomeMessage: "Hello! 👋 I'm your VAROTRADES AI assistant.\n\nHow can I help you today?",
    placeholder: "Type your message...",
    poweredBy: "Powered by AI",
    instantSupport: "24/7 Instant Support",
    newChat: "New chat",
    errorMessage: "Sorry, an error occurred. Please try again.",
    connectionError: "Sorry, a connection error occurred. Please try again later.",
    quickQuestion1: "How do I start trading?",
    quickQuestion2: "What are the fees?",
    quickQuestion3: "How to deposit?",
    quickQuestion4: "Is the platform secure?",
  },
  
  // Language names
  languages: {
    ar: "العربية",
    en: "English",
    es: "Español",
    de: "Deutsch",
    zh: "中文",
    ja: "日本語",
    he: "עברית",
  },
};

export default en;
